import React from 'react';
import { size } from 'lodash';

import AudioPlayer from './AudioPlayer';
import './styles/TimelinePage.scss';

export default class Footer extends React.Component {
  render() {
    let isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
    }

    if (size(this.props.episode)) {
      return (
        <div
          className='footer'
          style={{
            height: this.props.playerExpanded ? (isMobile ? '85px' : '135px') : '40px',
          }}
        >
          <AudioPlayer {...this.props} isMobile={isMobile} />
        </div>
      );
    } else {
      return (
        <div className='footer'>
          <a href='/'>Home</a>
          <a href='https://blog.clip.ps/'>Blog</a>
          <a href='/privacy'>Privacy</a>
          <a href='/terms'>Terms</a>
          <a href='/community'>Community</a>
          <a href='/links'>CasterLink</a>
        </div>
      );
    }
  }
}
